import Link from "next/link";
import { UrlObject } from "url";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import Text from "@ds/components/Text";
import RightArrow from "@icons/RightArrow";
import color from "@definitions/mui/color";
import { textLimit } from "@helpers/text";
import { SxProps } from "@mui/material";

export interface ListBoxItemProps {
  title: string;
  description?: string;
  width?: number | string;
  height?: number | string;
  minHeight?: number;
  onClick?: () => void;
  linkTo: string | UrlObject;
  sx?: SxProps;
}

const ListBoxItem: React.FC<ListBoxItemProps> = ({
  onClick,
  title,
  description,
  width = 280,
  height = 180,
  minHeight = 200,
  linkTo,
}) => {
  return (
    <Link href={linkTo}>

      <Box
        data-testid="test-click"
        onClick={() => (onClick?.())}
        sx={{
          width,
          height,
          minHeight,
          position: "relative",
          padding: 3,
          border: `1px solid ${color.grey.light}`,
          borderRadius: 2,
          cursor: onClick || linkTo ? "pointer" : "default",
        }}
      >
        <Box mb={1}>
          <Tooltip title={title} placement="bottom" followCursor>
            <Text sx={{ fontSize: 18 }}>
              {textLimit(title, 35)}
            </Text>
          </Tooltip>
        </Box>
        {description && (
          <Box>
            <Text color="general-mid" variant="body2">
              {textLimit(description, 80)}
            </Text>
          </Box>
        )}
        {(onClick || linkTo) && (
          <Box position="absolute" right={14} bottom={8}>
            <RightArrow style={{ color: color.primary.main }} />
          </Box>
        )}
      </Box>

    </Link>
  );
};

export default ListBoxItem;
